import { render, staticRenderFns } from "./atRegularTimeTable.vue?vue&type=template&id=f56d90de&scoped=true&"
import script from "./atRegularTimeTable.vue?vue&type=script&lang=js&"
export * from "./atRegularTimeTable.vue?vue&type=script&lang=js&"
import style0 from "./atRegularTimeTable.vue?vue&type=style&index=0&id=f56d90de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56d90de",
  null
  
)

export default component.exports